import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({

  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  titleMargin: {
    marginTop: '25px'
  },

  noTitleMargin: {
    marginTop: '17px'
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    height: 'auto',
    width: 'auto',
    borderRadius: '7px',
    background: '#FFF',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
  },
  itemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#4A4A4A',
    marginBottom: '10px'
  },
  contextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  modelName: {
    minWidth: 0,
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey700,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  reference: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.grey.grey300,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }
}));

export default useStyles;
